// src/Components/LoadingComp/LoadingScreen.js
import React from 'react';
import './loadingscreen.css';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <h1>EHIPASSIKO BUDDHIST CENTER, AUSTRALIA</h1>
        <img 
          src="/dharma.webp"  // This points to public/dharma.png
          alt="Wheel of Dharma" 
          className="spinning-wheel"
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default LoadingScreen;